<template>
  <div class="indexPage">
    <div class="onePageShow">
      <CommonOverlay
          :logo-src="logoSrc"
          :logout-src="logoutSrc"
          :music-src="musicSrc"
          :nick-gold="true"
          @nick="handleNick"
      />
      <!-- 主要内容区域 -->
      <div class="main-content">
        <!-- 标题区域 -->
        <div class="title-section">
          <img class="titleImgShow" src="@/assets/images/indexPage/titleShow.png" alt="">
        </div>
        <!-- 底部年度报告区域 -->
        <div class="report-section">
          <div class="report-content">
            <img class="reportContentImg" src="@/assets/images/indexPage/reportText.png" alt="">
          </div>
          <div v-if="showReportEnter" class="report-enter" @click="enterReport">
            <img class="reportEnterImg" src="@/assets/images/indexPage/enterBtn.png" alt="">
          </div>
        </div>

        <!-- 有缓存时展示“查看助力”入口（viewHelp.png） -->
        <div v-if="hasCache" class="help-entry" @click="enterHelp">
          <img class="helpEntryImg" src="@/assets/images/indexPage/viewHelp.png" alt="查看助力">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonOverlay from '@/components/CommonOverlay/index.vue'
// layout 已改为由 App 根节点通过 class + CSS 控制，不再需要每页绑定

import logoSrc from '@/assets/images/indexPage/logo.png'
import logoutSrc from '@/assets/images/indexPage/logOut.png'
import musicSrc from '@/assets/images/indexPage/musicLogo.png'

import { loadDetailCache, saveDetailCache } from '@/utils/detailCache'
import { saveTeamId } from '@/utils/userCache'
import { toggleBgm, isBgmPlaying } from '@/utils/music'
import { fetchDetailData } from '@/api/detail'
import { getPlayerAllInfos, getPlayerNames,loginNoRequired } from "@/api"
import SimpleEncrypt from '@/utils/simpleEncrypt'
import { checkChannelType } from '@/utils/channelType'

export default {
  name: 'indexPage',
  components: { CommonOverlay },
  data() {
    return {
      logoSrc,
      logoutSrc,
      musicSrc,
      hasCache: false,
      showReportEnter: this.shouldShowReportEnter(), // 控制"进入报告"按钮的显示
      allPlayerInfo: {},
      allPlayerNames: {},
      channelType: '', // 渠道，包括官网和混服
    }
  },
  mounted() {
    const cache = loadDetailCache()
    this.hasCache = !!(cache && cache.data)

    // 尝试自动播放音乐
    this.tryAutoPlayMusic()

    // 检查URL参数中是否有teamId，如果有则进行自动登录
    this.handleAutoLogin()

    // 完全参考detailPage的adjustSwiperHeight方法
    this.adjustPageHeight();

    // 绑定多种事件以确保iOS设备方向变化时能正确重绘
    this.bindOrientationEvents();

    // 预加载后续页面的资源
    this.preloadResources()
  },
  beforeDestroy() {
    // 清理所有事件监听
    this.unbindOrientationEvents();
  },
  computed: {},
  methods: {
    // 判断是否应该显示"进入报告"按钮（初始化时调用，避免闪烁）
    shouldShowReportEnter() {
      // 检查URL参数中是否有teamId
      const teamId = this.getQueryParam('teamId')

      // 没有免密参数，直接显示按钮
      if (!teamId) {
        console.log('初始化：没有teamId，显示按钮');
        return true;
      }

      // 有免密参数，初始化时隐藏按钮
      console.log('初始化：检测到teamId，隐藏按钮');
      return false;
    },

    // 尝试自动播放音乐
    async tryAutoPlayMusic() {
      // 如果音乐已经在播放，则不需要重复播放
      if (isBgmPlaying()) {
        console.log('音乐已在播放，跳过自动播放')
        return
      }

      try {
        console.log('尝试自动播放背景音乐...')
        await toggleBgm()
        console.log('自动播放背景音乐成功')
      } catch (error) {
        console.log('自动播放被浏览器阻止或播放失败:', error)
        // 播放失败时不做任何操作，音乐图标会保持静止状态
        // toggleBgm() 内部只有在成功播放时才会设置 SET_MUSIC_PLAYING 为 true
        // 所以播放失败时，store 状态仍为 false，音乐图标不会转动
      }
    },

    handleNick() {
      // TODO: 预留昵称点击逻辑
    },
    async enterHelp() {
      // 如果音乐未播放，则开始播放背景音乐（尊重用户的音乐偏好）
      if (!isBgmPlaying()) {
        try {
          await toggleBgm()
          console.log('自动开始播放背景音乐')
        } catch (error) {
          console.log('音乐播放失败:', error)
        }
      }
      this.$router.push({name: 'helpDetail'})
    },
    async enterReport() {
      // 如果音乐未播放，则开始播放背景音乐（尊重用户的音乐偏好）
      if (!isBgmPlaying()) {
        try {
          await toggleBgm()
          console.log('自动开始播放背景音乐')
        } catch (error) {
          console.log('音乐播放失败:', error)
        }
      }

      const cache = loadDetailCache()
      if (cache && cache.data) {
        // 有缓存：直接进详情页
        this.$store.commit('SET_DETAIL_DATA', cache.data)
        this.$router.push({name: 'detail'})
      } else {
        // 无缓存：先登录绑定
        this.$router.push({name: 'login'})
      }
    },
    getQueryParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    },
    // 自动登录处理逻辑
    async handleAutoLogin() {
      // 获取URL参数中的teamId
      const teamId = this.getQueryParam('teamId')
      console.log(teamId);

      // iOS设备检测
      const isIOSDevice = this.isIOSDevice();
      
      if (!teamId || !isIOSDevice) {
        console.log('没有teamId或非iOS设备，直接触发方向检测和重绘');
        // 直接触发方向检测和重绘方法
        this.handleOrientationChange();
        
        if (!teamId) {
          return // 没有teamId参数，不进行自动登录（按钮状态已在初始化时设置）
        }
      }

      if (teamId) {
        // 有teamId参数，执行免密登录流程（按钮已在初始化时隐藏）
        console.log('检测到免密登录参数，开始登录流程');

        try {
          // 开始调用toGetPlayerAllInfo
          await this.toGetPlayerAllInfo()
          
          // iOS设备且有teamId时，在toGetPlayerAllInfo完成后再执行方向判断和重绘
          if (isIOSDevice) {
            console.log('iOS设备，toGetPlayerAllInfo完成后执行方向检测和重绘');
            this.handleOrientationChange();
          }
          
          // 尝试解密teamId
          const decryptedTeamId = SimpleEncrypt.decrypt(teamId)
          console.log('解密后的decryptedTeamId:', decryptedTeamId);

          if (decryptedTeamId) {
            await this.toLoginNoRequired(decryptedTeamId)
          } else {
            this.removeTeamIdFromUrl()
          }
        } catch (error) {
          console.error('自动登录过程出错:', error)
        } finally {
          // 无论成功失败，都显示按钮
          console.log('免密登录流程完成，显示按钮');
          this.showReportEnter = true;
        }
      }
    },
    // 校验是否可以通过免密登录
    async toLoginNoRequired(decryptedTeamId) {
      try {
        const noRequireParam = {
          teamId: decryptedTeamId,
        }

        this.channelType = checkChannelType(decryptedTeamId)
        const res = await loginNoRequired(noRequireParam, this.channelType)
        const result = res.data
        if (result.code === 0) {
          await this.processLoginWithTeamId(decryptedTeamId)
        } else {
          console.log('免密登录失败了，code:', result.code)
          this.removeTeamIdFromUrl()
        }
      } catch (error) {
        console.error('处理登录失败:', error)
        this.removeTeamIdFromUrl()
      }
    },
    // 处理teamId登录
    async processLoginWithTeamId(decryptedTeamId) {
      try {
        // 调用fetchDetailData获取用户数据
        const detailParam = {
          teamId: decryptedTeamId,
          askType: '1',
          askTeamId: '1'
        }
        const res = await fetchDetailData(detailParam, this.channelType)
        const result = res.data

        if (result.code === 0) {
          let dataInit = result.data
          if (!dataInit.reviewData) {
            dataInit.reviewData = {}
          }
          if (dataInit.reviewData && dataInit.reviewData.maxAgentPlayer) {
            dataInit.maxAgentPlayerIds = dataInit.reviewData.maxAgentPlayer.split(',')
          }
          // 数据拼装
          const payload = this.dataAssembly(dataInit)
          this.$store.commit('SET_DETAIL_DATA', payload)
          saveDetailCache(payload)
          // 将昵称写入本地缓存
          let teamIdAndNick = {
            teamId: dataInit.teamId,
            nickName: dataInit.teamName
          }
          saveTeamId(JSON.stringify(teamIdAndNick))

          // 更新hasCache状态
          this.hasCache = true

          // 移除URL参数，防止刷新时再次触发
          this.removeTeamIdFromUrl()

          console.log('自动登录成功')
        } else {
          // fetchDetailData返回的code不为0，移除URL参数
          console.log('获取用户数据失败，code:', result.code)
          this.removeTeamIdFromUrl()
        }
      } catch (error) {
        console.error('处理登录失败:', error)
        this.removeTeamIdFromUrl()
      }
    },

    // 移除URL中的teamId参数
    removeTeamIdFromUrl() {
      const url = new URL(window.location)
      url.searchParams.delete('teamId')
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash)
    },

    // 拉所有球员信息
    toGetPlayerAllInfo() {
      return new Promise((resolve, reject) => {
        getPlayerAllInfos().then(res => {
          if (res.status === 200) {
            this.handleForIdKey(res.data).then(() => {
              this.toGetPlayerNames().then(() => {
                resolve()
              }).catch(reject)
            }).catch(reject)
          } else {
            reject('获取球员信息失败')
          }
        }).catch(reject)
      })
    },

    // 处理球员ID映射
    handleForIdKey(data) {
      return new Promise((resolve, reject) => {
        if (data.length > 0) {
          data.map(val => {
            if (val.player_id) {
              this.allPlayerInfo[val.player_id] = val
            } else {
              console.error('Missing player_id in:', val)
            }
          })
          resolve()
        } else {
          reject('No data provided')
        }
      })
    },

    // 获取球员名称
    toGetPlayerNames() {
      return new Promise((resolve, reject) => {
        getPlayerNames().then(res => {
          if (res.status === 200) {
            this.allPlayerNames = res.data
            resolve()
          } else {
            reject('获取球员名称失败')
          }
        }).catch(reject)
      })
    },


    // 数据拼装
    dataAssembly(data) {
      let dataInit = data
      dataInit.goalKingIdName = this.setDefault(dataInit, 'goalKingIdDaily')
      dataInit.reviewData.maxScorePlayerIdAgentName = this.setDefault(dataInit, 'maxScorePlayerIdAgent', 2)
      if (dataInit.reviewData.maxAgentPlayer) {
        dataInit.maxAgentPlayerNames = this.setGoodPlayerNames(dataInit, 'maxAgentPlayerIds')
      } else {
        dataInit.maxAgentPlayerNames = []
      }
      return dataInit
    },
    setGoodPlayerNames(row, key) {
      if (!row[key]?.length) return [];

      const {allPlayerInfo, allPlayerNames} = this;

      return row[key].map(val => {
        const playerInfo = allPlayerInfo[val];
        if (!playerInfo) return val;

        const playerName = playerInfo.player_name;
        return allPlayerNames[playerName]?.CN || allPlayerNames[playerName]?.EN || val;
      });
    },
    // 设置默认值
    setDefault(row, key1, level) {
      // 初始化默认返回值
      let handled = ''
      const levelData = (level === 2 && row.reviewData && Object.keys(row.reviewData).length > 0)
          ? row.reviewData
          : row
      // 如果 key1 不存在于 levelData 中，直接返回默认值
      if (!levelData[key1]) return handled
      // 获取玩家信息
      const playerInfo = this.allPlayerInfo[levelData[key1]]
      if (!playerInfo) return handled
      // 获取玩家名称
      const playerName = this.allPlayerInfo[levelData[key1]]?.player_name
      if (!playerName) return handled
      // 获取玩家名称的中文翻译
      return this.allPlayerNames[playerName]?.CN || handled
    },
    // 绑定方向变化相关的所有事件（针对iOS设备优化）
    bindOrientationEvents() {
      console.log('绑定iOS方向变化事件监听器');

      // 基本的resize事件
      window.addEventListener('resize', this.handleOrientationChangeDebounced);

      // iOS设备专用的方向变化事件
      window.addEventListener('orientationchange', this.handleOrientationChangeDebounced);

      // 视觉视口变化事件（iOS Safari地址栏显示隐藏）
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.handleOrientationChangeDebounced);
      }

      // 页面可见性变化（从后台切回前台时）
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      // 页面焦点事件（应用切换时）
      window.addEventListener('focus', this.handleOrientationChangeDebounced);
      window.addEventListener('pageshow', this.handleOrientationChangeDebounced);

      console.log('已绑定所有方向变化事件');
    },

    // 清理所有方向变化事件监听器
    unbindOrientationEvents() {
      console.log('清理iOS方向变化事件监听器');

      window.removeEventListener('resize', this.handleOrientationChangeDebounced);
      window.removeEventListener('orientationchange', this.handleOrientationChangeDebounced);

      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.handleOrientationChangeDebounced);
      }

      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('focus', this.handleOrientationChangeDebounced);
      window.removeEventListener('pageshow', this.handleOrientationChangeDebounced);

      // 清理防抖定时器
      if (this.orientationDebounceTimer) {
        clearTimeout(this.orientationDebounceTimer);
        this.orientationDebounceTimer = null;
      }

      console.log('已清理所有方向变化事件');
    },

    // 防抖处理的方向变化处理器
    handleOrientationChangeDebounced() {
      // 清除之前的定时器
      if (this.orientationDebounceTimer) {
        clearTimeout(this.orientationDebounceTimer);
      }

      // 设置新的定时器，300ms防抖
      this.orientationDebounceTimer = setTimeout(() => {
        this.handleOrientationChange();
      }, 500);
    },

    // 处理方向变化的核心方法
    handleOrientationChange() {
      console.log('检测到设备方向或视口变化');

      // 获取当前设备方向信息
      const orientation = screen.orientation || window.orientation;
      const isPortrait = window.innerHeight > window.innerWidth;

      console.log('当前方向信息:', {
        orientation: orientation,
        screenOrientation: screen.orientation ? screen.orientation.angle : 'unknown',
        windowOrientation: window.orientation,
        isPortrait: isPortrait,
        windowSize: `${window.innerWidth}x${window.innerHeight}`,
        screenSize: `${screen.width}x${screen.height}`
      });

      // 强制重新计算页面高度
      this.adjustPageHeight();

      // 强制重排重绘
      this.forceRepaint();

      console.log('方向变化处理完成');
    },

    // 处理页面可见性变化
    handleVisibilityChange() {
      if (!document.hidden) {
        console.log('页面重新可见，触发重绘');
        // 页面重新可见时，延迟一下再重绘，确保iOS完成了所有变化
        setTimeout(() => {
          this.handleOrientationChange();
        }, 500);
      }
    },

    // 强制重排重绘
    forceRepaint() {
      if (this.$el) {
        // 方法1: 临时修改display样式强制重排
        const originalDisplay = this.$el.style.display;
        this.$el.style.display = 'none';

        // 强制浏览器重排
        this.$el.offsetHeight;

        // 恢复display样式
        this.$el.style.display = originalDisplay;

        // 方法2: 使用transform触发硬件加速重绘
        this.$el.style.transform = 'translateZ(0)';

        // 方法3: 在下一帧清理transform
        requestAnimationFrame(() => {
          if (this.$el) {
            this.$el.style.transform = '';
          }
        });

        console.log('强制重排重绘完成');
      }
    },

    // 完全参考detailPage的adjustSwiperHeight方法
    adjustPageHeight() {
      // - use-design-size：固定 1334（配合全局缩放）
      // - use-fluid-size：使用真实视口高度，避免出现底部黑边留白
      if (this.$el) {
        const root = document.querySelector('.app-scale-root')
        const isFluid = root && root.classList.contains('use-fluid-size')

        if (isFluid) {
          // 使用视觉视口高度（iOS Safari 地址栏变化时更准确）
          const vv = window.visualViewport
          const h = (vv && vv.height) ? vv.height : window.innerHeight

          console.log('调整页面高度:', {
            visualViewportHeight: vv ? vv.height : 'undefined',
            windowInnerHeight: window.innerHeight,
            finalHeight: h
          });

          this.$el.style.height = `${h}px`
        } else {
          this.$el.style.height = `1334px`
        }
      }
    },

    // 检测是否为iOS设备
    isIOSDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // 检测iOS设备（iPhone、iPad、iPod）
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      
      // 检测iOS Safari浏览器（包括WebView）
      const isiOSSafari = /Safari/.test(userAgent) && /iPhone|iPad|iPod/.test(userAgent);
      
      // 检测iOS Chrome或其他浏览器
      const isiOSBrowser = /iPhone|iPad|iPod/.test(userAgent);
      
      console.log('iOS设备检测结果:', {
        userAgent: userAgent,
        isIOS: isIOS,
        isiOSSafari: isiOSSafari,
        isiOSBrowser: isiOSBrowser
      });
      
      return isIOS || isiOSBrowser;
    },

    // 预加载后续页面的资源 - 使用动态import确保打包后正常工作
    async preloadResources() {
      try {
        // loginPage/detail 资源列表 - 使用动态import
        const loginPageResources = await Promise.all([
          import('@/assets/images/loginPage/bgImg.png'),
          import('@/assets/images/detailPage/one/oneBg.png'),
          import('@/assets/images/detailPage/one/time.png'),
          import('@/assets/images/detailPage/one/time.png'),
          import('@/assets/images/detailPage/one/goldenMan.png'),
          import('@/assets/images/loginPage/topLine.png'),
          import('@/assets/images/loginPage/bottomLine.png'),
          import('@/assets/images/loginPage/bgCover.png'),
          import('@/assets/images/loginPage/bottomBg1.png'),
        ])

        // helpDetail 资源列表 - 使用动态import
        const helpDetailResources = await Promise.all([
          import('@/assets/images/help/titleText.png'),
          import('@/assets/images/help/middleBg.png'),
        ])

        // 合并所有资源
        const allResources = [...loginPageResources, ...helpDetailResources]

        // 预加载图片资源
        allResources.forEach((resource, index) => {
          // 延迟预加载，避免阻塞主要内容加载
          setTimeout(() => {
            const img = new Image()
            img.onload = () => {
              console.log(`预加载成功: `)
            }
            img.onerror = (error) => {
              console.warn(`预加载失败: ${resource.default}`, error)
            }
            // 使用import返回的default路径
            img.src = resource.default
          }, index * 50) // 每50ms加载一个资源，避免并发过多
        })

        console.log('开始预加载后续页面资源...')
      } catch (error) {
        console.warn('资源预加载失败:', error)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.indexPage {
  /*
    设计稿缩放方案下：页面高度应继承外层 1334 画布（100%），避免 100vh 参与计算造成留白/截断。
    小屏铺满模式会由全局 .use-fluid-size + 组件自身 width/height 逻辑决定（必要时可再加 media 覆盖）。
  */
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-image: url('@/assets/images/indexPage/bgImg.png');
  background-size: cover;
  background-position: center;
  /* 设计稿模式下保持内容为 750 宽（配合外层缩放），避免被拉伸到 100% */
  max-width: 750px;
  margin: 0 auto;

  // 第二层背景 bgCover
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('@/assets/images/indexPage/bgCover.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    pointer-events: none;
    z-index: 1;
  }

  // 顶部背景 topBg
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: auto;
    background-image: url('@/assets/images/indexPage/topBg.png');
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
    pointer-events: none;
    z-index: 2;
    aspect-ratio: 750 / 200; // 根据实际图片比例调整
  }
}

.horizontal {
  height: 100%;
  background: url("@/assets/images/indexPage/horizontalBg.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .textArea {
    display: flex;

    .leftImg {
      margin-right: 40px;

      img {
        height: 100px;
      }
    }
  }

  .rightText {
    text-align: left;
    font-size: 32px;
    font-family: 'FontMedium', sans-serif;
    color: white;
    display: flex;
    flex-flow: column;
    justify-content: center;

    p {
      padding: 0;
      margin: 0;
    }
  }
}

@media (max-width: 750px) {
  .indexPage {
    max-width: none;
    margin: 0;
  }
}

// 底部背景 bottomBg (页面底部)
.indexPage .main-content::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: auto;
  background-image: url('@/assets/images/indexPage/bottomBg.png');
  background-size: 100% auto;
  background-position: bottom center;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: 2;
  aspect-ratio: 750 / 300; // 根据实际图片比例调整
}


@keyframes musicPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

// 主要内容区域
.main-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  //position: relative;
}

// 标题区域
.title-section {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  text-align: center;
  width: 90%;

  .titleImgShow {
    width: 7rem;
    height: auto;
  }
}

// 底部报告区域
.report-section {
  position: absolute;
  bottom: 1.1rem;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 0 .55rem;

  .report-content {
    position: relative;

    .reportContentImg {
      height: 2.71rem;
      width: auto;
    }
  }

  .report-enter {
    position: relative;

    .reportEnterImg {
      width: 2.7rem;
      height: auto;
    }
  }
}

.help-entry {
  position: absolute;
  right: 0.55rem;
  bottom: 2.6rem; /* 放在“进入报告”按钮上方，避免遮挡 */
  z-index: 12;

  .helpEntryImg {
    width: 2.7rem;
    height: auto;
    display: block;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
